import React, { useLayoutEffect, useRef, useState } from 'react'

export default function Framed({
  media,
  headerText,
  children,
  visibleCloseButton = false,
  closeLabel = 'Back',
  closeButtonColor = 'rgba(0, 0, 0, 0.72)',
  backgroundColor = 'white',
}){
    const hasHeader = Boolean(children) || Boolean(headerText)
    const headerRef = useRef(null)
    const [headerHeight, setHeaderHeight] = useState(0)
    const iframeTop = hasHeader ? headerHeight : 0

    useLayoutEffect(() => {
      if (!hasHeader || !headerRef.current) {
        setHeaderHeight(0)
        return
      }

      const updateHeight = () => {
        if (headerRef.current) {
          // Use layout metrics (not getBoundingClientRect) so scale animations
          // on parent containers do not shrink the measured header height.
          const nextHeight = Math.max(
            headerRef.current.offsetHeight || 0,
            headerRef.current.scrollHeight || 0
          )
          setHeaderHeight(Math.max(0, nextHeight - 1))
        }
      }

      updateHeight()
      const rafId = requestAnimationFrame(updateHeight)
      const timeoutId = window.setTimeout(updateHeight, 600)

      if (typeof ResizeObserver !== 'undefined') {
        const observer = new ResizeObserver(() => updateHeight())
        observer.observe(headerRef.current)
        return () => {
          observer.disconnect()
          cancelAnimationFrame(rafId)
          window.clearTimeout(timeoutId)
        }
      }

      window.addEventListener('resize', updateHeight)
      return () => {
        window.removeEventListener('resize', updateHeight)
        cancelAnimationFrame(rafId)
        window.clearTimeout(timeoutId)
      }
    }, [hasHeader, children, headerText])

    return(
        <div className="framed" style={{ backgroundColor }}>
            {hasHeader && (
              <div className="framed-header" ref={headerRef}>
                {children ? (
                  children
                ) : (
                  <p className="framed-header-text">{headerText}</p>
                )}
              </div>
            )}
            {visibleCloseButton ? (
              <button
                type="button"
                className="framed-close-button"
                onClick={() => window.history.back()}
                aria-label={closeLabel}
                style={{ backgroundColor: closeButtonColor }}
              >
                <div className="framed-close-arrow" aria-hidden="true"></div>
              </button>
            ) : (
              <div className="fake-button" onClick={() => window.history.back()}></div>
            )}
            <iframe src={media} 
    style={{
        position: 'absolute',
        top: iframeTop,
        left:0,
        width:'100%',
        height: `calc(100% - ${iframeTop}px)`
    }}
    frameBorder="0"
    ></iframe>
        </div>
    )
    

}
